import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { FmlmSearchStepDeclaration } from "./Steps/FmlmSearchStep";
import { SearchInitStepDeclaration } from "./Steps/SearchInitStep";
import { SelectSearchDateStepDeclaration } from "./Steps/SelectDateStep";
import { SelectSearchLocationStepDeclaration } from "./Steps/SelectLocationStep";
import { SelectSearchPassengerTypeStepDeclaration } from "./Steps/SelectPassengerTypeStep";
import { FMLMSearchTransition } from "./Transition/FmlmSearchTransition";
import { SearchTransition } from "./Transition/SearchTransition";

export const searchStartupFlow = new FlowDefinition("SearchFlow");

searchStartupFlow.addStep(SearchInitStepDeclaration);
searchStartupFlow.addStep(SelectSearchDateStepDeclaration);
searchStartupFlow.addStep(SelectSearchLocationStepDeclaration);
searchStartupFlow.addStep(SelectSearchPassengerTypeStepDeclaration);
searchStartupFlow.addStep(FmlmSearchStepDeclaration);

searchStartupFlow.addLink("SearchStartupInit_Step", "SelectSearchStop_Step");
searchStartupFlow.addLink("SearchStartupInit_Step", "SelectSearchDate_Step");
searchStartupFlow.addLink("SearchStartupInit_Step", "SelectSearchPassengerType_Step");
searchStartupFlow.addLink("SearchStartupInit_Step", "FmlmSearchStep");
searchStartupFlow.addLink("FmlmSearchStep", "SearchStartupInit_Step");
searchStartupFlow.addLink("FmlmSearchStep", "SelectSearchStop_Step");

searchStartupFlow.addLink("SelectSearchStop_Step", "SearchStartupInit_Step");
searchStartupFlow.addLink("SelectSearchDate_Step", "SearchStartupInit_Step");
searchStartupFlow.addLink("SelectSearchPassengerType_Step", "SearchStartupInit_Step");

searchStartupFlow.addTransition(SearchTransition, "SearchStartupInit_Step");
searchStartupFlow.addTransition(FMLMSearchTransition, "FmlmSearchStep");

searchStartupFlow.setStartStep("SearchStartupInit_Step");

export const searchFlowStepDefinition = new StepDefinition({
  stepName: "SearchFlow",
  stepFlow: searchStartupFlow,
  contextIsolation: false,
});
